module.exports = __webpack_public_path__ + "e9c7e57991034842c1f744a671abaa08.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-120@2x.png
// module id = 500
// module chunks = 0